var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSelectTool = function SvgSelectTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 34
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M23.999 19.571H20.27l1.962 4.78a.653.653 0 0 1-.332.844l-1.728.754a.62.62 0 0 1-.82-.342l-1.866-4.54-3.047 3.134c-.406.418-1.064.096-1.064-.452V8.643c0-.576.7-.858 1.064-.452l9.999 10.284c.404.394.106 1.096-.439 1.096",
    fillRule: "evenodd"
  })));
};

export default SvgSelectTool;